const risk_ids = {
    L: "Low",
    M: "Moderate",
    H: "High",
    V: "Very High",
    E: "Extreme"
}

const nfdrs_risk_colors = {
    Low: 'rgba(108,161,98,255)',
    Moderate: 'rgba(0,170,233,255)',
    High: 'rgba(241,226,0,255)',
    'Very High': 'rgba(232,147,0,255)',
    Extreme: 'rgba(227,85,0,255)',
}

const nfdrs_risk_colors_alpha = {
    Low: 'rgba(108,161,98,0.7)',
    Moderate: 'rgba(0,170,233,0.7)',
    High: 'rgba(241,226,0,0.7)',
    'Very High': 'rgba(232,147,0,0.7)',
    Extreme: 'rgba(227,85,0,0.7)',
}

export { nfdrs_risk_colors, risk_ids, nfdrs_risk_colors_alpha }